/**
 * Implements a members route interceptor as a behavior.
 *
 * It must attached to the main layout.
 */

import Marionette from "backbone.marionette";
import Radio from "backbone.radio";

import ModalView from "../views/drilldown";
import DatatableLinkModel from "../models/datatable-link";

// import environment from "../common/environment";
import { createModal } from "../utils";

const globalChannel = Radio.channel("global");

class ProviderGroupsBehaviors extends Marionette.Behavior {
  initialize() {
    this.listenTo(
      globalChannel,
      "provider-groups-*-providers",
      this.createGenericModal
    );
    this.listenTo(
      globalChannel,
      "provider-groups-*-members",
      this.createGenericModal
    );
    this.listenTo(
      globalChannel,
      "providers-*-overview",
      this.createGenericModal
    );
  }

  createGenericModal(config) {
    const { returnRoute, returnRouteRefresh, endpoint, data } = config.toJSON();

    const viewOptions = {
      returnRoute,
      returnRouteRefresh,
    };

    const modelOptions = {
      endpoint,
      data,
    };

    this._createModalView(
      ModalView,
      viewOptions,
      DatatableLinkModel,
      modelOptions
    );
  }

  // instantiates the passed in view with its options and model
  _createView(View, viewOptions = {}, Model, modelOptions = {}) {
    const options = Object.assign({}, viewOptions, {
      model: Model ? new Model(modelOptions) : null,
    });

    // instantiate view
    new View(options);
  }

  // instantiates the passed in view on a generated modal with its options and model
  _createModalView(View, viewOptions = {}, Model, modelOptions = {}) {
    // create new modal and apply returned selector to view options
    Object.assign(viewOptions, {
      el: createModal(),
    });

    this._createView(View, viewOptions, Model, modelOptions);
  }
}

export { ProviderGroupsBehaviors as default };
